module.exports = {"allMissionLanguages":[{"value":1,"label":"English"},{"value":2,"label":"Yiddish"},{"value":3,"label":"French"},{"value":4,"label":"Hebrew"}],"availableMissionLanguages":[{"value":1,"label":"English"},{"value":2,"label":"Yiddish"},{"value":4,"label":"Hebrew"}]}


//////////////////
// WEBPACK FOOTER
// ./src/data/languages.json
// module id = 113
// module chunks = 0